import React from 'react';
import { FormattedMessage } from 'intl';
import { SystemTranslationKeys } from 'intl/keys';

import { Box, Typography } from '@mui/material';

const NotFoundPage = (): React.ReactElement => {
  return (
    <Box
      margin='dense'
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography
        sx={{ py: 2 }}
        margin='dense'
        variant='h3'
        component='span'
      >
        <FormattedMessage id={SystemTranslationKeys.id403NotFound} />
      </Typography>
      <Typography margin='dense' variant='h4' component='span'>
        <FormattedMessage id={SystemTranslationKeys.id403PageNotFoundExtended} />
      </Typography>
    </Box>
  );
};

export default React.memo(NotFoundPage);
